/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
    ContentBlock,
    Stack,
    Heading,
    InventoryPromoLink,
    Carousel,
    Box,
    useFlags,
} from 'sarsaparilla';
import { useGatewayTours } from '../../shared';

export function ToursContainer({ tourId, areTourDetailsLoading }) {
    const recAreaData = useSelector((state) => state?.timedEntry?.recArea);
    const { tours, status } = useGatewayTours(tourId, recAreaData);
    const { teGatewayTours } = useFlags();

    const renderSlides = () => {
        return tours?.map((tour, index) => {
            const {
                tour_id: localTourId,
                customImageUrl,
                customTourName,
                customLinkUrl,
                customLocation,
            } = tour;

            const clickTagCategory = 'Tickets';
            const clickTagLabel = `Additional recreation options on ${tourId}`;
            const clickTagAction = `${customTourName} - ${localTourId}`;

            return (
                <InventoryPromoLink
                    key={index}
                    className="te-tour-details-page__carousel-card"
                    imagePath={customImageUrl}
                    imageAlt={customTourName}
                    href={customLinkUrl}
                    heading={customTourName}
                    location={customLocation}
                    inventoryTags={['Ticket']}
                    clickTagCategory={clickTagCategory}
                    clickTagAction={clickTagAction}
                    clickTagLabel={clickTagLabel}
                />
            );
        });
    };

    if (areTourDetailsLoading || status !== 'IDLE' || !tours?.length || !teGatewayTours) {
        return null;
    }

    return (
        <Box background="extra-light-blue" paddingY="lg">
            <ContentBlock>
                <section>
                    <Stack space="gutter">
                        <div>
                            <Stack space={'lg'}>
                                <Heading
                                    headingLevel={2}
                                    appearance="h4"
                                    className="nav-homepage-section-header"
                                >
                                    Explore additional recreation options
                                </Heading>
                            </Stack>
                        </div>

                        <div>
                            <Carousel
                                slideTargetWidth={275}
                                hasGutters
                                hasPaddingBelow
                                className="mb-1"
                            >
                                {renderSlides()}
                            </Carousel>
                        </div>
                    </Stack>
                </section>
            </ContentBlock>
        </Box>
    );
}

ToursContainer.propTypes = {
    tourId: PropTypes.string,
    areTourDetailsLoading: PropTypes.bool,
};

ToursContainer.defaultProps = {
    tourId: '',
    areTourDetailsLoading: false,
};
